import React from 'react'
import type { SelectAsyncProps } from '@ztechapps/webui.input'
import { OptionComponent, SelectAsync } from '@ztechapps/webui.input'
import { buildGraphqlQuery, truncate } from '@ztechapps/common.utils'
import { Stack } from 'react-bootstrap'

//region GraphQL query
export const queries = buildGraphqlQuery('Blog', `_id title summary`)
//endregion

const OptionSimple = ({ data, ...rest }) => {
  return (
    <OptionComponent
      {...rest}
      label={
        <Stack>
          <div className={'fw-bold'}>{data?.title}</div>
          <div className={'fw-normal'}> - {truncate(data?.summary, 150)}</div>
        </Stack>
      }
    />
  )
}

const dataLoadOptions = ({ filter }) => ({
  query: queries?.allConfig?.query,
  filter: ({ input }) => ({
    $or: [{ title: { $regex: input, $options: 'i' } }, { summary: { $regex: input, $options: 'i' } }],
    ...filter,
  }),
  resultFieldName: 'allBlog',
})

export const BlogSelect = ({ filter, ...rest }: SelectAsyncProps) => {
  return (
    <SelectAsync
      {...{
        components: { Option: OptionSimple },
        placeholder: 'Type blog title',
        labelKey: 'title',
        noOptionsMessage: () => 'Cannot find any blogs.',
        dataLoadOptions: dataLoadOptions({ filter }),
        ...rest,
      }}
    />
  )
}
